export default __webpack_public_path__ + "static/media/nodejs.52cbf9a8.svg";